import { useState, useEffect } from 'react';
import { MenuItem, Select } from 'seagull';
import { useIoContext } from "../../contexts";
import styles from "./TimeSelector.module.scss";
import { getAvailableTimeSlots, getCurrentTimeSlot } from "./TimeSelector.utils";
import { jsx as _jsx } from "react/jsx-runtime";
const defaultHelperText = (now, tzAbbreviation) => "based on your timezone (".concat(tzAbbreviation || 'UTC', ")");
export default function TimeSelector(_ref) {
  let {
    onTimeChange,
    testId,
    currentDate
  } = _ref;
  const {
    getNow,
    getTimezoneAbbreviation
  } = useIoContext();
  const [selectedTime, setSelectedTime] = useState(getCurrentTimeSlot(currentDate, getNow()).dateTimeValue);
  const [availableSlots, setAvailableSlots] = useState(getAvailableTimeSlots(currentDate, getNow()));
  const helperText = defaultHelperText(getNow(), getTimezoneAbbreviation(getNow()));
  useEffect(() => {
    setAvailableSlots(getAvailableTimeSlots(currentDate, getNow()));
    const time = getCurrentTimeSlot(currentDate, getNow()).dateTimeValue;
    setSelectedTime(time);
    onTimeChange(time);
  }, [currentDate, onTimeChange]);
  const handleChange = event => {
    const newValue = event.target.value;
    setSelectedTime(newValue);
    onTimeChange(newValue);
  };
  return /*#__PURE__*/_jsx(Select, {
    label: "Time",
    width: 287,
    "data-testid": testId,
    value: selectedTime,
    onChange: handleChange,
    helperText: helperText,
    SelectProps: {
      autoWidth: true,
      MenuProps: {}
    },
    children: availableSlots.map(_ref2 => {
      let {
        dateTimeValue: value,
        timeLabel: label,
        slotTestId: testPrefix
      } = _ref2;
      return /*#__PURE__*/_jsx(MenuItem, {
        className: styles.menuItem,
        value: value,
        "data-testid": "".concat(testId, "-").concat(testPrefix),
        children: label
      }, value);
    })
  });
}